import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Params, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, filter, map } from 'rxjs';

import { GetCollectionApi } from '../../infrastructure/state/actions/collection.actions';
import { collectionLoaded } from '../../infrastructure/state/selectors/collection.selectors';

@Injectable()
export class CollectionGuard {
    public canActivate(
        store: Store,
        params: Params,
    ): Observable<UrlTree | boolean> {
        const slug = params.slug;

        store.dispatch(GetCollectionApi({ slug }));

        return store.select(collectionLoaded).pipe(
            filter(loaded => loaded !== null && loaded !== undefined),
            map(loaded => loaded)
        );
    }
}

export const canActivateCollection: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    return inject(CollectionGuard).canActivate(inject(Store), route.params);
};
